import { Text, Button } from "@virkesborsen/ui-component-library";
import { useDrone } from "../../../context/DroneContext";

export default function TreebulaStudio() {
  const { openCheckout } = useDrone();
  
  return (
    <div className="h-full w-full bg-stone-50">
      <div className="max-w-[1320px] mx-auto flex flex-col">
        <section className="flex flex-col gap-12 p-4 lg:p-16">
          <div className="flex flex-col gap-4">
            <Text variant="overlineLargeRegular">Podcast</Text>
            <Text variant="sectionHeaderMedium">
              Treebula Studio Special – Drönaranalys
            </Text>

            <Text variant="introLeadSmallRegular" className="text-pebble-500">
              I det här specialavsnittet presenterar Carl Johan Moberg och Per
              Hedberg en helt ny tjänst som gör det enklare att få koll på
              skogen – oavsett var du befinner dig. Med hjälp av drönarteknik
              kan skogsägare nu beställa en flygning direkt från sin digitala
              skogsbruksplan och få resultatet integrerat i planen.
            </Text>
          </div>
          <div className="flex w-full rounded-3xl overflow-hidden mb-8">
            <iframe
              src="https://www.youtube.com/embed/A13fAEUWwTI"
              frameborder="0"
              allow="autoplay; encrypted-media"
              referrerPolicy="strict-origin-when-cross-origin"
              allowfullscreen
              title="video"
              className="w-full h-[400px] lg:h-[728px]"
            />
          </div>
          <div className="flex rounded-xl p-6 bg-green-forest-green-500 justify-between items-center flex-col gap-6 lg:flex-row lg:gap-2">
            <div className="flex flex-col gap-4">
              <Text variant="subheaderSmallMedium" className="text-white-50">
                Vill du få prisförslag?
              </Text>
              <Text variant="introLeadSmallRegular" className="text-white-50">
                Kostnaden är baserad på typ av paket samt den totala ytan som
                ska flygas.
              </Text>
            </div>
            <div className="flex flex-col w-full gap-6 lg:w-auto lg:flex-row lg:gap-3">
              <Button tw variant="quaternary" onClick={openCheckout}>
                Beställ drönarflygning
              </Button>
              <Button
                tw
                variant="outline"
                className="border-spring-yellow-500 text-spring-yellow-500 hover:bg-green-forest-green-400 hover:text-spring-yellow-400"
                onClick={() => {
                  window.location.href = "/kontakta-oss/";
                }}
              >
                Kontakta rådgivare
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
